module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('span', {
    staticClass: "Bookman-Italic-in-Poem CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("books by amanda lovelace")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("the")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "Bookman-Italic-in-Poem CharOverride-4"
  }, [_vm._v("women are some kind of magic")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("series:")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t"
  }, [_c('span', {
    staticClass: "Bookman-Italic-in-Poem CharOverride-5"
  }, [_vm._v("the princess saves herself in this one (#1)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Bookman-Italic-in-Poem CharOverride-5"
  }, [_vm._v("the witch doesn’t burn in this one (#2)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("the mermaid’s voice returns in this one (#3)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("slay those dragons: a journal for writing  your own story")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("***")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("the")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("things that h(a)unt")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("duology:")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered t"
  }, [_c('span', {
    staticClass: "Bookman-Italic-in-Poem CharOverride-5"
  }, [_vm._v("to make monsters out of girls (#1)")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Centered"
  }, [_c('span', {
    staticClass: "Bookman-Italic-in-Poem CharOverride-5"
  }, [_vm._v("to drink coffee with a ghost (#2)")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "Bookman-Italic-in-Poem CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1 p2"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("this is dedicated")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("to the one ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("who loves ketchup")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("as much as")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("i do.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Heliotype-headers",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("trigger warning")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("child abuse,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("eating disorders,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("sexual assault,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("self-harm,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("violence,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("cheating,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("death,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("gore,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("blood,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("trauma,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("grief,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("& possibly")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("more.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1 t"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("remember to practice")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("self-care before,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("during, & after")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("reading.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "epub:type": "toc",
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "Heliotype-headers p2",
    attrs: {
      "id": "_idParaDest-4"
    }
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("co")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("n")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("t")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("e")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("n")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ts")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Justified ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "#/To_Drink_Coffee_ebook1#_idTextAnchor006"
    }
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-3"
  }, [_vm._v("ghost-mother")])])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Justified ParaOverride-2 t"
  }, [_c('a', {
    attrs: {
      "href": "#/To_Drink_Coffee_ebook2#_idTextAnchor040"
    }
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-3"
  }, [_vm._v("ghost-daughter")])])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Justified ParaOverride-2 t"
  }, [_c('a', {
    attrs: {
      "href": "#/To_Drink_Coffee_ebook3#_idTextAnchor071"
    }
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-3"
  }, [_vm._v("sun-showers")])])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("when she thinks")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("i have forgotten her,")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("every phone")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("rings off the hook—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("every television screen")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("turns to static—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("every faucet")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("twists on & off—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("every clock")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("strikes three a.m.—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("every book")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("flies off the shelves—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("every cabinet")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("swings wide open—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("every stool")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("turns upside down—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("every door")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("locks & unlocks itself—")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("every lightbulb")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("explodes into pieces.")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("i haven’t ")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("forgotten;")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("there are")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("just some things")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left t"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("i choose")])]), _vm._v(" "), _c('p', {
    staticClass: "Poem-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("not to remember.")])]), _vm._v(" "), _c('p', {
    staticClass: "JB-Attribute-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-10"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("- ")]), _c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("welcome home.")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "Poem-Justified"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("whenever i think of you, i envision our little white kitchen table. inside the drywall, i  imagine years of collected stories &   laughter burrowed like chestnuts from  stowaway squirrels. my secrets are hidden  among them, too—the ones you expertly  ignored so you could still look at me & see  the perfect daughter who never existed. none of these memories would be  complete without our coffee. so i sit down  at our little white kitchen table. i pour not  one but two cups. i wait & wait & wait even  though i know you won’t show up to hear  what i have to say.")])]), _vm._v(" "), _c('p', {
    staticClass: "JB-Attribute-Flush-Left"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("- communication was never our strong suit.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    staticClass: "_idGenObjectStyle-Disabled",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "ouji board pointing to hello",
      "src": "image/ToDrinkCoffeeWithAGhost_edited_01.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abe3f740","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/To_Drink_Coffee_ebook.vue
// module id = 60
// module chunks = 0